/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Item type. Omit or null for regular line item, 'separator' for a visual section header.
Separator items only use name and description — all financial fields are ignored.
 * @nullable
 */
export type CustomDocumentItemType = typeof CustomDocumentItemType[keyof typeof CustomDocumentItemType] | null;


export const CustomDocumentItemType = {
  separator: 'separator',
} as const;
